import React from 'react';
import dayjs from 'dayjs';
import { MemberProfile } from '../../../../model/members/MemberProfile';
import { MembershipCategory } from '../../../../model/members/MembershipCategory';
import { useFormatCurrency } from '../../../../hooks/useFormatters';

interface TransactionSummaryProps {
  amount: number | null;
  useCustomAmount?: boolean;
  defaultAmount?: number | null;
  membershipCategory?: MembershipCategory | null;
  member?: MemberProfile;
  customFields?: React.ReactNode;
  showCategoryChange?: boolean;
  showValidToChange?: boolean;
  validToDate?: Date | string | null;
}

export const TransactionSummary: React.FC<TransactionSummaryProps> = ({
  amount,
  useCustomAmount = false,
  defaultAmount,
  membershipCategory,
  member,
  customFields,
  showCategoryChange = false,
  showValidToChange = false,
  validToDate
}) => {
  const formatCurrency = useFormatCurrency();
  if (amount == null) return null;

  const isValidToChanged = () => {
    if (!validToDate || !member?.validTo) return false;
    return !dayjs(validToDate).isSame(dayjs(member.validTo), 'day');
  };

  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#f6ffed', 
      border: '2px solid #52c41a', 
      borderRadius: '8px',
      textAlign: 'center',
      marginBottom: '16px'
    }}>
      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#52c41a', marginBottom: '8px' }}>
        Transaction Summary
      </div>
      <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#1890ff', marginBottom: '16px' }}>
        {formatCurrency(amount)}
      </div>
      <div style={{ marginTop: '12px', fontSize: '14px', color: '#666', textAlign: 'left' }}>
        {membershipCategory && (
          <>
            <div><strong>Membership Category:</strong> {membershipCategory.name}</div>
            <div><strong>Payment Frequency:</strong> {membershipCategory.paymentFrequency}</div>
          </>
        )}
        {useCustomAmount && defaultAmount !== null && (
          <div style={{ color: '#fa8c16' }}>
            <strong>Custom Amount:</strong> Active (Default: {formatCurrency(defaultAmount ?? 0)})
          </div>
        )}
        {customFields}
        {showValidToChange && validToDate && (
          <>
            <div><strong>ValidTo Date:</strong> {dayjs(validToDate).format('DD/MM/YYYY')}</div>
            {isValidToChanged() && member && (
              <div style={{ color: '#fa8c16' }}>
                <strong>ValidTo Date Change:</strong> Will update from {member.validTo ? dayjs(member.validTo).format('DD/MM/YYYY') : 'Not set'} to {dayjs(validToDate).format('DD/MM/YYYY')}
              </div>
            )}
          </>
        )}
        {showCategoryChange && membershipCategory && member && membershipCategory.name !== member.membershipCategory.name && (
          <div style={{ color: '#fa8c16' }}>
            <strong>Category Change:</strong> Will update from {member.membershipCategory.name} to {membershipCategory.name}
          </div>
        )}
      </div>
    </div>
  );
};

